import { tmpdir } from 'node:os';
import { join } from 'node:path';

function isWinOS() {
    return process.platform === "win32";
}
export function getPipeFileName(pipe: string) {
    return isWinOS() ? `\\\\.\\pipe\\${pipe}` : join(tmpdir(), `${pipe}.sock`);
}
